module.exports = __webpack_public_path__ + "static/polls-questions-52eaea6f46a68286c572abd1d8def468.png";